import { gql } from '@apollo/client';

export const GET_ANIMALS_WITH_TREATMENT = gql`
  query getAnimalsWithTreatment(
    $startDate: String
    $endDate: String
    $location: String
  ) {
    getAnimalsWithTreatment(
      input: { startDate: $startDate, endDate: $endDate, location: $location }
    ) {
      animalSpecies
      animalSex
      animalOwnerStatus
      fieldName
      total
    }
  }
`;
